import React, { useState } from "react";
import classnames from "classnames";

import styles from "./TimeRange.module.css";

import "react-datepicker/dist/react-datepicker.css";
import "./index.css";
import DatePicker from "react-datepicker";
import { registerLocale } from  "react-datepicker";
import zhCN from 'date-fns/locale/zh-CN';
import { format } from "date-fns";
registerLocale('zhCN', zhCN);

interface Props {
  timeRangeEnd: any;
  timeRangeStart: any;
  updateTimeRangeEnd: (end: any) => void;
  updateTimeRangeStart: (start: any) => void;
}

function TimeRange(props: Props) {
  const { timeRangeEnd, timeRangeStart, updateTimeRangeEnd, updateTimeRangeStart } = props;
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  return (
    <div className={styles.container}>
      <div className={styles.label}>上拍时间</div>
      <div className={styles.value}>
        <button
          className={classnames(styles.default, {
            [styles.active]: !timeRangeEnd  && !timeRangeStart
          })}
          onClick={() => {
            setStartDate(null);
            setEndDate(null);
            updateTimeRangeStart(null);
            updateTimeRangeEnd(null);
          }}
        >
          不限
        </button>
        <div className={styles.wrapper}>
          <span className={styles.symbol}></span>
          <DatePicker 
            selected={startDate} 
            onChange={(date:any) => {
              setStartDate(date)
              updateTimeRangeStart(format(date,"yyyy-MM-dd"))
            }} 
            locale="zhCN"
            className={styles.input}
            dateFormat="yyyy-MM-dd"
            maxDate={endDate}
          />
        </div>
        <div className={styles.spacer}></div>
        <div className={styles.wrapper}>
          <span className={styles.symbol}></span>
          <DatePicker 
            selected={endDate} 
            onChange={(date:any) => {
              setEndDate(date)
              updateTimeRangeEnd(format(date,"yyyy-MM-dd"))
            }} 
            locale="zhCN"
            className={styles.input}
            dateFormat="yyyy-MM-dd"
            minDate={startDate}
          />
        </div>
      </div>
    </div>
  );
}

export default TimeRange;
